module.exports = __webpack_public_path__ + "assets/img/icon-monitor-purple.5ec8f165.png";